<template lang="pug">
v-container
  v-form(v-if="loaded && userPersonalData" ref="form")
    div.button-container.mb-1.mx-auto
      v-btn( :class='{ "button-cancel" : disabledForm}' icon dark color="black" @click="closeEditForm" )
        v-icon mdi-close
      h3.mr-3 Договор
      v-btn( @click="editForm" icon)
        v-icon mdi-pencil
    div.mx-auto.qwe
      v-text-field.test( v-model="userPersonalData.firstname" label="Имя" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.lastname" label="Фамилия" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.middlename" label="Отчество" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.address" label="Адрес" outlined dense :disabled="disabledForm" )
      DatePicker(v-model="userPersonalData.birthday" label="Дата рождения (гггг-мм-дд)" :disabled="disabledForm")
      v-text-field.test.mt-2( v-model="userPersonalData.passportNumber" label="Серия и номер"  v-mask="'#### ######'" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.passportIssuedBy" label="Кем выдан" outlined dense :disabled="disabledForm" )
      DatePicker(v-model="userPersonalData.passportIssuedDate" label="Дата выдачи (гггг-мм-дд)" :disabled="disabledForm")
      v-text-field.test.mt-2( v-model="userPersonalData.passportCode" label="Код подразделения" v-mask="'###-###'" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.snils" label="СНИЛС" v-mask="'###-###-### ##'" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.inn" label="ИНН" v-mask="'############'" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.docnumber" label="Номер договора" outlined dense :disabled="true" )
      DatePicker(v-model="userPersonalData.docdate" label="Дата договора (гггг-мм-дд)" :disabled="true" :docDate="true")
      v-text-field.test( v-model="userPersonalData.bik" label="БИК" outlined dense :disabled="disabledForm" )
      v-text-field.test( v-model="userPersonalData.paymentAccount" label="Расчётный счёт" outlined dense :disabled="disabledForm" )
    div.button-save.mx-auto
      v-btn( v-if="!disabledForm" @click="saveEditProfile")
        span Сохранить
  div.loader.mx-auto
    v-progress-circular.mb-3( v-if="!loaded" :size="50" color="primary" indeterminate )
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DatePicker from "./DatePicker.vue";

const defaultItem = {
  user_id: 0,
  firstname: '',
  middlename: '',
  lastname: '',
  address: '',
  passportNumber: '',
  passportIssuedBy: '',
  passportIssuedDate: '',
  passportCode: '',
  birthday: '',
  snils: '',
  inn: '',
  docnumber: '',
  docdate: '',
  bik: null,
  paymentAccount: null

}
export default {
  components: {
    DatePicker
  },

  data: () => ({
    loaded: false,
    disabledForm: true,
    userPersonalData: defaultItem,
  }),

  beforeMount() {

    if(!this.personalData) {
      this.loadUser()
      this.loadPersonalData().then(() => {
        this.userPersonalData = {...this.personalData}
        this.loaded = true
      })
    }
    
    if(this.personalData){
      this.userPersonalData = {...this.personalData}
      this.loaded = true
    }
  },

  computed: {
    ...mapState("user", ['personalData', 'userInfo']),
  },

  methods: {
    ...mapActions("user", ['saveProfile', 'loadPersonalData', 'loadUser']),
    ...mapMutations("user", ['setPersonalData']),
    editForm() {
      this.disabledForm = false
    },

    closeEditForm() {
      this.loaded = false
      this.userPersonalData = {...this.personalData}
      setTimeout(() => {
        this.loaded = true
        this.disabledForm = true
      }, 500);
      
    },

    saveEditProfile() {
      this.loaded = false
      if(this.userPersonalData.bik == '') this.userPersonalData.bik = null
      if(this.userPersonalData.paymentAccount == '') this.userPersonalData.paymentAccount	 = null
      this.userPersonalData.user = {...this.userInfo}
      if(this.$refs.form.validate()){
        this.saveProfile(this.userPersonalData).then(() => {
          this.setPersonalData(this.userPersonalData)
          this.loaded = true
          this.disabledForm = true
        })
      } else {
        if (window.confirm('Не все введенные данные соотвествуют формату, или некоторые поля не заполнены')) {
          this.loaded = false
          this.userPersonalData = {...this.personalData}
          setTimeout(() => {
            this.loaded = true
            this.disabledForm = true
          }, 500);
        }
        
      }
      
    }
  }
}
</script>
<style scoped>
.qwe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 400px;
}
.test {
  width: 100%;
}
.button-container {
  display: flex;
  max-width: 400px;
  justify-content: space-between;
}
.button-cancel {
  visibility: hidden;
}
.button-save {
  display: flex;
  justify-content: flex-end;
  max-width: 400px;
}
.datePicker{
  width: 400px !important;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 400px;
}
</style>